/**
 * Format an employee's reference number for display: zero-pad to at least 3
 * digits (1 -> "001", 12 -> "012", 1234 -> "1234"). Empty string when unset.
 */
export function formatReferenceNumber(value?: number | null): string {
  return value == null ? "" : String(value).padStart(3, "0");
}
